import { FLYBITS } from '../constants';
import axios from '../utils/axios';

export const generateWebhook = async (accessToken: string, tenantId: string): Promise<string> => {
    let result;
    const response = (await axios.post(FLYBITS.IDP_HOST + `/management/tenants/${tenantId}/api-token`, {}, {
        headers: {
            'Authorization': accessToken
        }
    }));
    if (200 === response.status) {
        result = response.data.id
    }
    return result
}



// WEBPACK FOOTER //
// ./src/services/webhook.ts